import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import CentreSummary from "./components/CentreSummary";
import OtherSummary from "./components/OtherSummary";
import HaulierSummary from "./components/HaulierSummary";
import { SummaryContainer } from "./SummaryList.styled";
import Tabs from "./components/Tabs";
/**
 * site summary,
 * Path - /site/view/{id}/summary
 * @see See [Site - Summaries](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3458269185/Site+-+Summaries)
 * @component
 */
const SummaryList = (props) => {
  const { t, entityId, countryId } = props;

  const [activeTab, setActiveTab] = useState("centre");

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <SummaryContainer>
      <Tabs toggleTab={toggleTab} activeTab={activeTab} />
      {activeTab === "centre" && (
        <CentreSummary countryId={countryId} entityId={entityId} />
      )}
      {activeTab === "haulier" && (
        <HaulierSummary countryId={countryId} entityId={entityId} />
      )}
      {activeTab === "other" && (
        <OtherSummary countryId={countryId} entityId={entityId} />
      )}
    </SummaryContainer>
  );
};
SummaryList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SummaryList);
